<p>
  modal-template works!
</p>
